const nb_no = {};

export default nb_no;
